var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orgTree"},[_c('ts-drag-scroll',{staticClass:"dragscroll",staticStyle:{"height":"80vh"}},[_c('ul',{style:(_vm.style)},[_c('child-item',{attrs:{"model":_vm.treeData,"append":_vm.append,"edit":_vm.edit,"remove":_vm.remove,"images":_vm.images}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }